import { del, get, post, put } from "./api_helper";

import * as url from "./url_helper";

export const getLogging = (data) => post(url.LOGIN, data);
export const forgetPassword = (data) => post(url.FORGET_PASSWORD, data);
export const resetPassword = (token, data) =>
  post(`${url.RESET_PASSWORD}?token=${token}`, data);

// Distributor
export const createDistributor = (data) => post(url.DISTRIBUTOR, data);
export const getDistributorList = (filters) => get(url.DISTRIBUTOR, filters);
export const getDistributor = (id) => get(`${url.DISTRIBUTOR}/${id}`);
export const updateDistributor = (id, data) =>
  put(`${url.DISTRIBUTOR}/${id}`, data);
export const updateDistributorStatus = (id, data) =>
  put(`${url.DISTRIBUTOR}/status/${id}`, data);
export const deleteDistributor = (id) => del(`${url.DISTRIBUTOR}/${id}`);

//profile
export const updateProfile = (data) => put(url.PROFILE, data);

//change password
export const changePassword = (data) => put(url.PASS_CHANGE, data);
//Admin
export const createAdmin = (data) => post(url.ADMIN, data);
export const getAdminList = (filters) => get(url.ADMIN, filters);
export const getAdmin = (id) => get(`${url.ADMIN}/${id}`);
export const updateAdmin = (id, data) => put(`${url.ADMIN}/${id}`, data);
export const updateAdminStatus = (id, data) =>
  put(`${url.ADMIN}/status/${id}`, data);
export const deleteAdmin = (id) => del(`${url.ADMIN}/${id}`);
